export default __webpack_public_path__ + "static/media/Sume_CarlosSanchez.013cee45.png";